import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.md};
`

export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(155px, 1fr));
  gap: 12px;
`

export const CardItem = styled('a')`
  display: flex;
  cursor: pointer;
  flex-direction: column;
  height: 145px;
  max-width: 200px;
  border-radius: 4px;
  background-color: ${theme.colors.neutral.white};
  border: 1px solid ${theme.colors.neutral.clear};
  overflow: hidden;
  text-decoration: none;
`

export const CardImage = styled.img`
  width: 100%;
  height: 60px;
  min-height: 60px;
  object-fit: cover;
  background: grey;
`

export const CardTexts = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${theme.spacing.sm};
  gap: ${theme.spacing.xs};

  p {
    line-height: 120%;
  }

  strong {
    color: ${theme.colors.neutral.black};
    font-weight: ${theme.typography.weight.xl};
  }
`
